import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  unReadNotificationCount: 0,
  allCategories: [],
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    setUnReadNotificationCount(state, action) {
      state.unReadNotificationCount = action.payload;
    },
  },
});

export const { setUnReadNotificationCount, setAllCategories } =
  commonSlice.actions;

export default commonSlice.reducer;
